import { __assign } from "tslib";
import React from 'react';
import { SettingsConsumer } from '../SettingsContext';
export var withSettings = function (WrappedComponent) { return function (props) { return (React.createElement(SettingsConsumer, null, function (settings) { return React.createElement(WrappedComponent, __assign({}, props, { settings: settings })); })); }; };
//# sourceMappingURL=withSettings.js.map